import { Icon as LegacyIcon } from '@ant-design/compatible';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
    button: {
        flexShrink: 0,
        color: "#646BDB",
        textTransform: "capitalize",
        border: "1px solid #27272F",
        borderRadius: 4,
        background: "transparent",
        height: '40px',
        padding: "0 30px",
        boxShadow: "none",
        fontSize: 14,
        margin: "0 10px 0 0",

        "&:hover": {
            color: "#fff",
            backgroundImage: "linear-gradient(to left, #27272F 0%, #27272F)",
            boxShadow: "none",
        },
        "&:disabled > .MuiButton-label": {
            color: "#aaa !important",
        },
        "&:disabled": {
            background:
                "repeating-linear-gradient(-45deg, transparent, transparent 3px, #e4e4e4 3px, #e4e4e4 8px ), linear-gradient(to bottom, #eee, #eee)",
            boxShadow: "none",
            cursor: "not-allowed",
            border: "none",
        },
    },
}));

/**
 * CustomSecondaryButton component.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.disabled - Whether the button is disabled.
 * @param {function} props.buttonClick - The button click event handler.
 * @param {string} props.icon - The button start icon.
 * @param {Object} props.style - The button style.
 * @param {string} props.title - The button title.
 * @param {boolean} props.loading - Whether the button is in loading state.
 * @param {string} props.label - The button label.
 * @param {"reset"|"button"|"submit"} props.type - The button label.
 * @returns {JSX.Element} The rendered CustomSecondaryButton component.
 */
export default function CustomSecondaryButton(props) {
    const classes = useStyles();

    return (
        <Button
            disabled={props.disabled}
            variant="contained"
            color="secondary"
            className={classes.button}
            onClick={(event) => props.buttonClick?.(event.currentTarget)}
            startIcon={props.icon ? <LegacyIcon type={props.iconType} theme={props.iconTheme} /> : null}
            style={props.style ? props.style : null}
            title={props.title}
            type={props.type || "button"}
        >
            {props.loading ? (
                <i
                    className="fa fa-refresh"
                    style={{
                        animation: "spin 1s infinite linear",
                    }}
                />
            ) : (
                props.label
            )}
        </Button>
    );
}
